module.exports = __webpack_public_path__ + "static/media/eventos-gratis.acd640b8.svg";